/** Word-level IPA overrides for Finnish. */
export const fi: Record<string, string> = {
  // G2P handles all Finnish words correctly. Overrides here are only
  // needed for words where G2P produces an incorrect entry.
};
